export enum ApiClientStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}
